export default {
  summary: 'Fehlende Keycloak-Berechtigungen',
  details: 'Dem aktuellen Benutzer fehlen die erforderlichen Client-Rollen in Keycloak. Das Erstellen neuer oder bearbeiten bestehender Benutzer ist daher nicht möglich. Bitte weisen Sie dem Benutzer die fehlenden Rollen zu oder wenden Sie sich an den Nitrex-Support.',
};
